export const initType = (data,type) => {
    let id = null
  
    data.forEach(item => {
        if (item.name == type) {
            id = item.id
        }
    });
    return id
}